//
// GraphSkinModel.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AttributesModel";
import "@sas-dvr/ltjs-commons/styles/DataSkin";
import "@sas-dvr/ltjs-commons/styles/KPISkin";
import "@sas-dvr/ltjs-commons/styles/BlendMode";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "@sas-dvr/ltjs-commons/models/attributes/GraphSkinModelInterface";

var GraphSkinModel = createModule("gtl::GraphSkinModel", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::AttributesModel"], EventDispatcher, [
    ,
    {
        blendEndColorFactor: 5,
        blendStartColorFactor: 5,
        glowBlur: 3,
        dataSkin: 4,
        blendMode: 4,
        glowColor: 10,
        kpiSkin: 4,
        glowColorFactor: 5,
        glowThickness: 1,
        blendStartColor: 10,
        blendEndColor: 10,
    },
    ,
    ,
    {
        copyFromBundle: [0,1],
        asGraphSkinModelInterface: [1],
        setStyle: [0,1],
        setStyleElement: [0,4],
        setStyleElementChain: [0,[4]],
        copyFrom: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default GraphSkinModel;
